<template>
  <div class="cart">
      <Cart />
      <router-view></router-view>
  </div>
</template>

<script>
import Cart from '../components/Cart.vue'

export default {
    name: 'CartView',
    components: {
        Cart
    }
}
</script>
